import request from '@/utils/request'

// 查询banner列表
export function listBanner(query) {
  return request({
    url: '/biz/admin/advert/banner/list',
    method: 'get',
    params: query
  })
}

// 查询banner分页
export function pageBanner(query) {
  return request({
    url: '/biz/admin/advert/banner/page',
    method: 'post',
    data: query
  })
}

export function bannerPosition(query) {
  return request({
    url: '/biz/admin/advert/banner/type/list',
    method: 'get',
    params: query
  })
}

export function pageMerchantBanner(query) {
  return request({
    url: '/biz/admin/advert/banner/merchant/page',
    method: 'post',
    data: query
  })
}

// 查询banner详细
export function getBanner(data) {
  return request({
    url: '/biz/admin/advert/banner/detail',
    method: 'post',
    data: data
  })
}

// 新增banner
export function addBanner(data) {
  return request({
    url: '/biz/admin/advert/banner/add',
    method: 'post',
    data: data
  })
}

// 修改banner
export function updateBanner(data) {
  return request({
    url: '/biz/admin/advert/banner/edit',
    method: 'post',
    data: data
  })
}

// 删除banner
export function delBanner(data) {
  return request({
    url: '/biz/admin/advert/banner/delete',
    method: 'post',
    data: data
  })
}
